module.exports = __webpack_public_path__ + "static/media/maternite.ec2e6b56.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/maternite.jpeg
// module id = 1160
// module chunks = 0